export const getEnumLowerCaseKey = <E>(typeEnum: E, value: number): string =>
  typeEnum[value].toLowerCase();
